import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Beneficjent } from '../../../models/beneficjent';
import { PreviewDataWrapperComponent } from '../../preview-data-wrapper/preview-data-wrapper.component';
import { PreviewDataType } from '../../../enums/preview-data-type.enum';
import { ConstLabelReaderPipe } from '../../../pipes/const-label-reader.pipe';
import { RODZAJ_DOKUMENTU_LABELS } from '../../../enums/rodzaj-dokumentu.enum';
import { PLEC_LABELS } from '../../../enums/plec.enum';
import { STAN_CYWILNY_LABELS } from '../../../enums/stan-cywilny.enum';

@Component({
  selector: 'app-preview-beneficiary-details',
  imports: [PreviewDataWrapperComponent, ConstLabelReaderPipe],
  templateUrl: './preview-beneficiary-details.component.html',
  styleUrl: './preview-beneficiary-details.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PreviewBeneficiaryDetailsComponent {
  public beneficiary = input.required<Beneficjent>();
  protected readonly PreviewDataType = PreviewDataType;
  protected readonly DOCUMENT_TYPE_LABELS = RODZAJ_DOKUMENTU_LABELS;
  protected readonly MARTIAL_STATUS_LABELS = STAN_CYWILNY_LABELS;
  protected readonly GENDER_LABELS = PLEC_LABELS;
}
